/* eslint-disable react-hooks/exhaustive-deps */
import {
    ActionButton,
    Select
  } from "components"
  import { Fragment, useEffect, useMemo } from "react"
  import {
    Controller,
    FormProvider,
    useForm,
    useFormContext,
  } from "react-hook-form"
  import moment from "moment"
  import { FormStateProjectProfile } from "../types/ProfileTypes"
  import { convertNumber, useToggle } from "utils"
  import { SpendMoneyType } from "../types/SpendMoneyTypes"
  
  
  type Action = "add" | "edit"
  
  type ItemProps = {
      index?: number
      action: Action
      defaultValues?: SpendMoneyType
      isHideForm?: boolean
      onCancelEditing?: () => void
      onDeleteData?: () => void
      onSubmitData: (value: SpendMoneyType) => void
      dataProject: FormStateProjectProfile
      dropdownBoq: {
        value:string,
        label:string
      }[]
  }
  
  export function TableSpendMoneyItem(props: ItemProps) {
      const isHideForm = useToggle(props.isHideForm ?? true)
      const defaultValues: SpendMoneyType = useMemo(
          () => ({
                finance_detail_id: props.defaultValues?.finance_detail_id ?? 0,
                data_source: props.defaultValues?.data_source ?? 0,
                data_source_id: props.defaultValues?.data_source_id ?? 0,
                coa_id: props.defaultValues?.coa_id ?? 0,
                memo: props.defaultValues?.memo ?? "",
                amount: props.defaultValues?.amount ?? 0,
                position: props.defaultValues?.position ?? 0,
                referensi:props.defaultValues?.referensi ?? "",
                group_card: props.defaultValues?.group_card ?? 0,
                group: props.defaultValues?.group ?? "",
                card_id: props.defaultValues?.card_id ?? 0,
                trade_name: props.defaultValues?.trade_name ?? "",
                project_transaction_id:props.defaultValues?.project_transaction_id ?? null,
                project_id: props.defaultValues?.project_id ?? 0,
                transaction_date:props.defaultValues?.transaction_date ?? '',
                coa_code: props.defaultValues?.coa_code ?? "",
                coa_name: props.defaultValues?.coa_name ?? "",
                trx_code: props.defaultValues?.trx_code ?? "",
                trx_date:props.defaultValues?.trx_date ?? "",
                project_boq_id: props.defaultValues?.project_boq_id ?? 0,
                boq_name: props.defaultValues?.boq_name ?? "",
                trx_source_id: props.defaultValues?.trx_source_id ?? 0,
                trx_source:props.defaultValues?.trx_source ?? 0,
                trx_amount:props.defaultValues?.trx_amount ?? 0
            }),
          [props.defaultValues]
      )
  
      const methods = useForm<SpendMoneyType>({
          defaultValues,
          // resolver: yupResolver(validationBoqSchema)
      })
  
      useEffect(() => methods.reset(defaultValues), [defaultValues])
  
      const { watch } = methods;
      const account = `${watch('coa_code')} - ${watch('coa_name')}`;
      
    return (
      <FormProvider {...methods}>
        <tr className="">
          {isHideForm.isActive ? (
            <td colSpan={9} />
          ) : (
            <Fragment>
              <td className="text-center">{Number(props.index)+1}</td>
              <td >
                <Controller
                  control={methods.control}
                  name="trx_code"
                  render={({ field }) => (
                    <div>{field.value}</div>
                  )}
                />
              </td>
  
              <td>
                <Controller
                  control={methods.control}
                  name="transaction_date"
                  render={({ field }) => (
                    <div>{moment(field.value).format('DD/MM/YYYY')}</div>
                  )}
                />
              </td>
  
              <td>
                <Controller
                  control={methods.control}
                  name="group"
                  render={({ field }) => (
                    <div>{field.value}</div>
                  )}
                />
              </td>

              <td>
                <Controller
                  control={methods.control}
                  name="trade_name"
                  render={({ field }) => (
                    <div>{field.value}</div>
                  )}
                />
              </td>
  
              <td>
                <div>{account}</div>
              </td>
  
              <td>
                <Controller
                  control={methods.control}
                  name="memo"
                  render={({ field }) => (
                    <div>{field.value}</div>
                  )}
                />
              </td>
  
  
              <td>
                <Controller
                  control={methods.control}
                  name="amount"
                  render={({ field }) => (
                    <>{convertNumber(Number(field.value)).intoCurrency}</>
                  )}
                />
              </td>
  
              <td className="min-w-[100px]">
               <BOQ dropdown={props.dropdownBoq}/>
              </td>
  
          
              <td className="text-center">
                <section className="flex justify-center items-center">
                  {props.action === "edit" && (
                    <ActionButton.Close
                      permission="AT021"
                      onClick={props?.onCancelEditing}
                    />
                  )}
  
                  <ActionButton.Add
                    permission="AT021"
                    onClick={() => {
                      methods.handleSubmit((data) =>
                        props.onSubmitData(data)
                      )()
                    }}
                  />
  
                  {props.action === "add" && (
                    <ActionButton.Close
                      permission="AT021"
                      onClick={isHideForm.toggle}
                    />
                  )}
                </section>
              </td>
            </Fragment>
          )}
        </tr>
      </FormProvider>
    )
  }
  
  
  type BoqDropdownType={
    dropdown:{
      value:string,
      label:string
    }[]
  }
  function BOQ (props:BoqDropdownType) {
      
      const { control, setValue } = useFormContext<SpendMoneyType>()
     
      return (
        <Fragment>
          <Controller
            control={control}
            name="project_boq_id"
            render={({ field, fieldState }) => {
              return (
                <section>
                  <Select
                    className="w-full"
                    placeholder="Select BOQ"
                    error={fieldState.error?.message}
                    options={props.dropdown}
                    value={
                      field.value
                        ? props.dropdown.find((item) => Number(item.value) === field.value)
                        : null
                    }
                    onChange={(e) => {
                        field.onChange(e?.value)
                        setValue("boq_name", e?.label ?? "")
                    }}
                  />
                </section>
              )
            }}
          />
        </Fragment>
      )
    }